<template>
  <v-app style="margin-top:0px;" >
      <v-card flat v-bind:style="{ 'background-image': 'linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url(' + banner + ')' }" class="tst">
          <v-container>
              <h1 style="margin-top:20px;">{{ countryName }}</h1>
          </v-container>
      </v-card>
<div class="container con" >
      <div class="row" style="margin-top:-100px; " >
        <div class="col-lg-9 col-md-9 col-sm-12" >
      <v-card flat style="border: 1px solid #b6b6b6;">
      <v-container>
          <div class="row" style="padding-top:20px;padding-left:15px;padding-right:15px;">
            <h2 class="country-heading m-2 " >WHY STUDY ABROAD IN {{ countryName }}</h2>
            <img :src="image" style="width: 50%;height:300px;" />
          <div class="col-lg-12 col-md-12 col-sm-12" style="color:grey;margin-top:50px;text-align: justify;">
            <h3 class="country-heading"><strong>Study in Netherlands</strong></h3>
            <p>The Netherlands, sometimes known as Holland, is a nation in northwest Europe that also has possessions abroad in the Caribbean. Among the four nations that make up the Kingdom of the Netherlands, it is the biggest. The Netherlands has twelve provinces and borders the North Sea on the north and west, as well as Germany to the east and Belgium to the south. In the North Sea, it has maritime boundaries with Belgium, Germany, and the United Kingdom. The official language of the nation is Dutch, while the province of Friesland also recognizes West Frisian as an official language. In the Caribbean, the three official languages are Dutch, English, and Papiamento.</p>
            <p>Almost 17 million people call the Netherlands, commonly referred to as Holland, their nation of residence. The Netherlands is a highly developed and multicultural nation. The place is a highly popular choice for those looking to study abroad. The majority of international students opt to study in the Netherlands. The nation welcomes overseas students from more than 150 different nations each year and provides them with high-quality education and a variety of work options.</p>
            <h4 class="country-heading"><strong>Why to study in Netherlands?</strong></h4>
            <p>The environment will be international and global</p>
            <p>Cost of study is cheaper.</p>
            <p>Creative approaches to education</p>
            <p>Reasonable costs of life</p>
            <p>English is used to teach a variety of degrees.</p>
            <p>Exceptional chances to travel</p>
            <p>International acclaim for degrees</p>
            <p>Dutch universities that rank highly</p>

            <p>The Netherlands' universities are well-known for providing top-tier higher education internationally. International students submit applications each year for undergraduate and graduate programs. Members of the academic community from all over the world and in Europe rank the universities in the Netherlands based on the quality of their research and their evaluations. The top international universities in the Netherlands for 2023 are mentioned below.</p>


        

          <div class="body table-responsive">
                    <table class="table table-bordered" style="margin-top: 10px;">
                        <thead>
                          <tr style="background-color: #f48d8d;">
                            <th style="text-align: center;">Universities</th>
                            <th style="text-align: center;">QS Ranking 2023</th>
                            <th style="text-align: center;">US News Ranking 2022-23</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td >University of Amsterdam</td>
                            <td style="text-align: center;">58</td>
                            <td style="text-align: center;">61</td>
                          </tr>
                          <tr>
                            <td >Delft University of Technology</td>
                            <td style="text-align: center;">61</td>
                            <td style="text-align: center;">169</td>
                          </tr>
                          <tr>
                            <td >Utrecht University</td>
                            <td style="text-align: center;">112</td>
                            <td style="text-align: center;">44</td>
                          </tr>
                          <tr>
                            <td >Wageningen University & Research</td>
                            <td style="text-align: center;">124</td>
                            <td style="text-align: center;">89</td>
                          </tr>
                          <tr>
                            <td >Leiden University</td>
                            <td style="text-align: center;">131</td>
                            <td style="text-align: center;">74</td>
                          </tr>
                          <tr>
                            <td >Eindhoven University of Technology</td>
                            <td style="text-align: center;">138</td>
                            <td style="text-align: center;">342</td>
                          </tr>
                          <tr>
                            <td >University of Groningen</td>
                            <td style="text-align: center;">145</td>
                            <td style="text-align: center;">88</td>
                          </tr>
                          <tr>
                            <td >Erasmus University Rotterdam</td>
                            <td style="text-align: center;">208</td>
                            <td style="text-align: center;">65</td>
                          </tr>
                          <tr>
                            <td >University of Twente</td>
                            <td style="text-align: center;">212</td>
                            <td style="text-align: center;">400</td>
                          </tr>
                          <tr>
                            <td >University of Groningen</td>
                            <td style="text-align: center;">214</td>
                            <td style="text-align: center;">82</td>
                          </tr>

                        </tbody>
                      </table>
          </div>

    
          <h4 class="country-heading"> <strong>Frequently taken courses in the Netherlands</strong></h4>
              <p>Over 1700 bachelors, masters, and other degree programs are offered to students in the Netherlands. The top ten disciplines of study in the Netherlands, in order of popularity, are accounting, engineering, health care, social science, law, computer science, and the arts.</p>
              <p>The price of education in the Netherlands</p>
              <p>For foreign students, studying in the Netherlands is a cheaper study-abroad alternative than other locations like the UK and US. Research Universities, Institute for International Education, Universities of Applied Sciences (UAS), and Others make up the two categories of universities in the Netherlands. Local and European students pay the same amount to study in the Netherlands, while foreign students typically find applied science colleges to be less expensive than research universities. International students are required to pay institutional fees that are determined by universities and may vary per institution. For bachelor's degrees and master's degrees, some of the top-ranked institutions in the Netherlands charge up to €15,000 and €25,000 year, respectively. International students' costs for a UAS can start as little as </p>
              <p>The price of education in the Netherlands</p>
              <p>Study at €7–8,000 and never go beyond €10,000.</p>
              <p>Students from Suriname, other EU/EEA nations, and the Netherlands often pay the "statutory tuition fees," which are less expensive. This cost is the same at all universities and is established by the Dutch government. The "institutional tuition fees," which are often greater, must be paid by all other overseas students.</p>
              <p>Level Type Annual tuition costs on average</p>
              <div class="body table-responsive">
                      <table class="table table-bordered" style="margin-top: 10px;">

                          <tbody>
                            <tr>
                              <td style="text-align: center;">Bachelors</td>
                              <td>6,000 – 15,000 EUR</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">Masters</td>
                              <td>8,000 – 25,000 EUR</td>
                            </tr>
                          </tbody>
                        </table>
            </div>
              <p>Living expenses in the Netherlands</p>
              <p>International students looking to attend a university abroad will find the Netherlands to be a fantastic option. In contrast to nations like the UK and the US, the cost of living in the Netherlands is low. When planning to study in the Netherlands, it is crucial for international students to be well-prepared, and the most crucial preparation is to think about your living expenditures. This covers lodging, literature, clothing, food, and transportation. In the Netherlands, a student should budget between €800 and €1,100 a month.</p>
              <p>Housing In the Netherlands, a standard room runs between € 300 and € 600 a month.</p>
              <p>Food</p>
              <p>Most higher education institutes provide affordable, hot meals. Several typical costs:</p>
              <p>Netherlands's Cost of Living</p>
              <p>For foreign students who want to attend institutions abroad, the Netherlands is a fantastic option. Compared to nations like the UK and the US, the Netherlands has a cheap cost of living. International students must be well-prepared before beginning their studies in the Netherlands, and the most crucial preparation is to think about your living expenditures. This covers lodging, clothing, books, transportation, and meals. A student in the Netherlands should budget between €800 and €1,100 per month.</p>
              <p>Housing The monthly rent for a typical room in the Netherlands is from €300 to €600.</p>
              <p>Food</p>
              <p>Most institutes of higher education provide affordable, hot meals. Typical prices include:</p>
              <p>Living expenses in the Netherlands</p>
              <p>For foreign students who want to study abroad in a country that</p>
              <p>In a café, a cup of coffee or tea costs €3, while a cheese sandwich costs €4.</p>
              <p>Dinner costs €12,50 at a typical student eatery.</p>
              <p>Transportation Riding a bike around town is simple. In the city, a single bus charge is around</p>
             
              <div class="body table-responsive">
                      <table class="table table-bordered" style="margin-top: 10px;">

                          <tbody>
                            <tr>
                              <td style="text-align: center;">Accommodation</td>
                              <td>€350- €1000</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">Food</td>
                              <td>€150- €170</td>
                            </tr>
                            <tr>
                              <td style="text-align: center;">Travel</td>
                              <td>€35- €70</td>
                            </tr>
                          </tbody>
                        </table>
            </div>         
             <p>The Student Visa for the Netherlands</p>
             <p>To enter the Netherlands for study or research, foreign students need a visa and a work permit. The procedure for obtaining a Netherlands student visa consists of two steps :</p>
             <p>For entry into the Netherlands, you will need an MVV.</p>
             <p>Within a month of their arrival in the nation, students get the VRV, or Residence Permit.</p>
             <p>A "short stay visa" or "Schengen visa" may be required if your stay is less than 90 days. Depending on your nationality, you may require both an entrance visa (MVV) and a resident permit for visits longer than 90 days. (VVR).</p>
             <p>Validity</p>
             <p>You will typically be able to travel to all of the Schengen member states with the visa. Your stay in the Schengen region is constrained to a maximum of 90 days over the course of 180 days if you have a short-stay visa. This implies that after spending 90 days in the Schengen region, you cannot enter the region again for another 90 days. An entrance visa is likewise only good for 90 days, and a longer-term residency permit is supposed to come after it.</p>
             <p>Student grants and education loans for the Netherlands</p>
             <p>Scholarships are the finest method to pay for your studies in the Netherlands. For international students, especially those from outside the EEA, the Netherlands provides several scholarship possibilities as well as choices for student loans. In order to cover their tuition costs, Dutch universities provide merit-based scholarships to overseas students. Major financial institutions now provide loans at attractive interest rates, making it very straightforward for international students to apply for education loans in the Netherlands. The following scholarships are offered to overseas students:</p>
             <ul>
              <p>Amsterdam Scholarships</p>
              <p>Orange Tulip Awards</p>
              <p>Program for Radboud Scholarships</p>

             </ul>
             <p>possibilities for part-time employment in the Netherlands</p>
             <p>International students have the option of working part-time in the Netherlands, but they are only permitted to do so during the months of June, July, and August, and not both. Students can handle the cost of studying and living in the Netherlands by working part-time. Dutch public health insurance is necessary as soon as you hold a (part-time) employment.</p>
             <p>In the Netherlands, foreign students are permitted to undertake 10 to 16 hours per week of part-time employment.</p>
             <p>Students who work part-time can make up to 20 euros per hour, or around 1,700 rupees.</p>
             <p>Permit to work in the Netherlands after graduation</p>
             <p>The Dutch educational system provides high-quality academic options as well as numerous employment prospects. After graduating from one of the Dutch universities, international students are granted a post-study work permit. International graduates must get the Search/Orientation Year or “zoekjaar in Dutch, which permits post-study employment. Students must apply for this permission in accordance with new rules that became effective on March 1, 2016, three years after finishing their degree program. Additionally, graduates from the top 100 universities in the world are requesting this visa in order to work productively in the Netherlands.</p>

           
          </div>     
        </div>
        </v-container>
    </v-card>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6;">
                  <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Interested in studying abroad?</h3>
                  </div>
                  <v-container v-if="otp==false">
                      <v-form ref="form" v-model="valid" lazy-validation>
                          <v-layout row wrap >
                              <v-flex xs12 style="padding-top:10px;" >
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" v-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCountry"
                                   :items="countries"
                                   color="primary"
                                   label="Preferred Country *"
                                   item-text="countryName"
                                   item-value="countryName"

                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;">
                                  <v-autocomplete
                                   outline 
                                   style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                   v-model="selectedCourse"
                                   :items="courses"
                                   color="primary"
                                   label="Preferred Course *"
                                   item-text="courses"
                                   item-value="courses"
                                  ></v-autocomplete>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>

                  <v-container v-if="otp==true">
                      <v-form ref="form1" v-model="valid" lazy-validation>
                          <v-layout row wrap>
                              <v-flex xs12>
                                  <label>Enter Your OTP here *</label>
                                  <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                              </v-flex>
                              <v-flex xs12 style="padding-top:10px;text-align:center;">
                                  <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                              </v-flex>
                          </v-layout>
                      </v-form>
                  </v-container>
          </v-card>
          <v-card flat style="background-size:cover;padding:30px;border: 1px solid #b6b6b6; margin-top: 10px;">
            <div style="background-color:black;color:white;text-align:center;padding:10px;background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;">
                      <h3>Universities</h3>
                  </div>
             <marquee direction="up" scrollamount="3" style="margin-top:20px;height:150px ; ">
               <h5 style="margin-bottom:20px;color:#f12525" v-for="item in featuredUniversities" :key="item.id">{{ item.universityName }}</h5>

             </marquee>
          </v-card>

              <div class="">
                <h2 class="m-4" >Global Study <span style="font-weight:600">Destinations</span></h2>
              </div>
            <v-card @click="onCountry(item)" v-for="item in countries" :key="item.id" elevation="10" :style="{backgroundImage: `url(${item.image})`}" class="tourtheme hvr mb-3">
              <div style="margin:0px;cursor: pointer; ">
                <h4 class="mytxt" style="color:whitesmoke;padding:5px;margin:-10px;border-radius: 0px;margin-top: 125px;">{{ item.countryName }}</h4>
              </div>
            </v-card>

        </div>
      </div>
    </div>
      <v-dialog v-model="dialog" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>
  </v-app>
</template>

<script>
import config from "../../config.json";
import moment from 'moment';
export default {
  components: {
  },
  data() {
    return {
      tab: null,
      valid: true,
      btnSave: false,
      btnSave1: false,
      dialog: false,
      status: false,
      pin: 0,
      otp: false,
      name: [],
      featuredUniversities: [],

      ielts: true,
      toefl: false,
      gre: false,
      sat: false,
      gmat: false,

      details: null,
      image: null,
      banner: null,
      countryId: null,
      countryName: sessionStorage.getItem("countryName"),

      countries: [],
      selectedCountry: null,

      courses: [],
      selectedCourse: null,

      form: {
        name: null,
        email: null,
        mobileNumber: null
      },
      form1: {
        otp: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
    };
    
  },
  
   mounted() {
    // this.axios
    //     .get(config.API + `country/author/${this.$route.params.id}`, {
    //       headers: {
    //         Authorization: "bearer " + sessionStorage.getItem("token")
    //       }
    //     })
    //     .then(res => {
    //       let _data = res.data.author;
    //       this.details = _data;
          
    //       if(_data.image!=null) {
    //         this.image = config.API + 'country/files1/' + _data.image;
    //       }
    //       if(_data.banner!=null) {
    //         this.banner = config.API + 'country/files2/' + _data.banner;
    //         console.log(this.banner);
    //       }
    //     })
    //     .catch(() => {
    //       this.$Progress.fail();
    //     });

      this.countryName = sessionStorage.getItem("countryName");
      this.image = sessionStorage.getItem("image");
      this.banner = sessionStorage.getItem("banner");
      this.countryId = sessionStorage.getItem("countryId");
        this.axios
      .get(config.API + `country/authors`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let list = res.data.authors;
        console.log(list);

        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          if(element.id!=this.countryId) {
            this.countries.push({
            id: element.id,
            countryName: element.countryName.toUpperCase(),
            src: config.API1 + "country/files/" + element.src,
            image: config.API1 + "country/files1/" + element.image
            })
          }
        }

        console.log(this.countries);
      });

      this.axios
    .get(`https://api.worldwin.org/api/Levels`, {
      headers: { Authorization: "Bearer " + sessionStorage.token }
    })
    .then(res => {
      let list = res.data;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        
        this.courses.push(element.levelName)
      }
    });


    this.axios
        .post(
          config.API + `university/search`,
          {
            countryId: this.countryId
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          let list = res.data.result;
          console.log(list);

          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            
            this.featuredUniversities.push({
              id: element.id,
              universityName: element.universityName,
              src: config.API1 + "university/files/" + element.src
            })
          }
            })
        .catch(err => {
        });
   },

 methods: {
   blg(item) {
     sessionStorage.setItem("blogTitle", item.title);
     sessionStorage.setItem("blogDescription", item.description);
     sessionStorage.setItem("blogSrc", item.src);
     this.$router.push("/blogDetail/" + item.id );
   },
   getOtp() {
    if (this.$refs.form.validate()) {
      this.btnSave = true;
      this.axios
        .post(
          config.API + `enquiry/author`,
          {
            name: this.form.name,
            email: this.form.email,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            country: this.selectedCountry,
            course: this.selectedCourse,
            page: 'Country Details',
            date: moment().format('MMMM Do YYYY')
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(res => {
          console.log(res);
          this.name = this.form.name.split(' ');
          let firstName = this.name[0];
          let lastName = null;

          if(this.name.length > 2) {
            lastName = this.name[1] + this.name[2]
          }
          else {
            lastName = this.name[1]
          }

          let comment = "Preferred Country: " + this.selectedCountry + ", Preferred Course: " + this.selectedCourse;
          this.axios
        .post(
          `https://api.worldwin.org/api/Leads1`,
          {
            firstName: firstName,
            lastName: lastName,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            cmsId: JSON.parse(res.data.result.id),
            email: this.form.email,
            guardianName: null,
            comment: comment,
            pageName: 'Country Details',
            guardianNo: 0,
            guardianEmail: null,
            relation: null,
            address: null,
            nature: null,
            source: "Website",
            document: false,
            documentType: null,
            notes: null,
            levelId: 0,
            leadDetails: null,
            leadTrainings: null
          },
          {
            headers: {
              Authorization: "bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          this.dialog = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error(`Mobile no is already registered`);
          this.btnSave = false;
        });
        })
        .catch(() => {
          this.$toaster.error("Mobile no is already registered");
          this.btnSave = false;
        });
      }
      /* this.pin = Math.floor(1000 + Math.random() * 9000);
      this.axios
        .post(
          config.API + 'enquiry/otp',
          {
            name: this.form.name,
            mobileNumber: JSON.parse(this.form.mobileNumber),
            otp: this.pin
          },
          {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          }
        )
        .then(() => {
          this.otp = true;
          this.btnSave = false;
        })
        .catch(() => {
          this.$toaster.error("Mobile number already exists!!");
          this.btnSave = false;
        }); */
    /* } else {
      this.$toaster.error(`Required field are empty!!`);
    } */
  },
  onCountry(item) {
  sessionStorage.setItem("countryName", item.countryName);
  sessionStorage.setItem("image", item.image);
  sessionStorage.setItem("banner", item.banner);
  sessionStorage.setItem("countryId", item.id); 
  ////this.$router.push("/countrydetail/" + item.id );
  if(item.countryName=='UK') {
    this.$router.push("/study-in-uk");
  }
  else if(item.countryName=='DUBAI') {
    this.$router.push("/study-in-dubai");
  }
  else if(item.countryName=='SINGAPORE') {
    this.$router.push("/study-in-singapore");
  }
  else if(item.countryName=='USA') {
    this.$router.push("/study-in-usa");
  }
  else if(item.countryName=='AUSTRALIA') {
    this.$router.push("/study-in-australia");
  }
  else if(item.countryName=='CANADA') {
    this.$router.push("/study-in-canada");
  }
  
 },

    onSubmit() {
      if (this.$refs.form1.validate()) {
        if(this.pin == this.form1.otp) {
          this.btnSave1 = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.mobileNumber),
              country: this.selectedCountry,
              course: this.selectedCourse,
              page: 'Test Preparation',
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }
            this.axios
          .post(
            `http://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave1 = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave1 = false;
          });
        }
        else {
          this.$toaster.error("Please put a valied OTP");
        }
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    cancel() {
      this.form.name = null;
      this.form.email = null;
      this.form.mobileNumber = null;
      this.otp = false;
      this.dialog = false;
    },
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://www.pexels.com/photo/selective-focus-photo-of-man-using-laptop-1438081/');
  background-size: cover;
  height:200px;
}
.tst {
  border-radius:0px;
  height:300px;
  background-size: cover;
  color: white !important;
    
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .5;
  position: absolute;
  width: 100%;
}
.tourtheme {
  height: 190px;
  margin: 15px;
  background-size: 100%;
  transition: background-size 1s ease-in-out !important;
}
.tourtheme:hover {
  background-size: 120%;
}
.partner {
    margin-top: 15px;
    text-align: center;
    font-size: 23px;
    background-image: linear-gradient(to right, #f19a28 , #f12525);
    border-radius: 0px !important;
    color: whitesmoke !important;
}
.country-heading {
  color:#EC1616;
}
.country p {
  font-weight: 300;
  color:#666666;
  text-align: justify;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
div.scroll { 
                margin:4px, 4px; 
                padding:4px; 
                width: auto; 
                height: 254px; 
                overflow-x: hidden; 
                overflow-x: auto; 
                text-align:justify; 
            }

.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.link:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hvr:hover {
  cursor: pointer;
  border-radius: 5px !important;
  border : 1px solid;
  border-color: black !important;
  transition-duration: 0.7s;
  text-decoration: none !important;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.con {
  margin-top: -100px;
  max-width: 1300px;
}
@media screen and (min-width: 768px){
  .con {
    margin-top: 0px!important;}

  }
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
